// extracted by mini-css-extract-plugin
export default {"wrapper":"Carousel-module__wrapper--erdDr","content":"Carousel-module__content--ea4J0","arrows":"Carousel-module__arrows--BYc_o"};